import React from "react";
import { observer } from "mobx-react";
import styled from "styled-components"
import { OrbitComponent } from "../../base-components/orbit-component/orbit-component";
import Device from "../../../../sdk/src/utils/device/device";
import {ComponentServicesPick} from "../../../services/component-services-pick";
import {withServices} from "../../../react-hooks/with-services";

const Label = styled.span`
    color: ${({theme}) => theme.colors.brandPrimary};
`;
const Value = styled.span`
    color: ${({theme}) => theme.colors.brandSecondary};
`;

interface ClientHintsShowcaseProps extends ComponentServicesPick<'clientDevice'> {
    
}

const ComponentBody = observer(class ClientHintsShowcase extends OrbitComponent<ClientHintsShowcaseProps> {
    private renderUserAgentString() {
        return <div style={{padding: "5px 0"}}>
            <div>USER AGENT</div>
            <div>
                <span style={{paddingRight: 20}}><Label>.navigator.userAgent</Label> (string) "<Value>{window.navigator.userAgent}</Value>"</span>
            </div>
        </div>;
    }
    private renderClientHints() {
        if (!this.props.clientDevice.detected.clientHintsAvailable) {
            return <div style={{padding: "5px"}}>CLIENT HINTS NOT AVAILABLE</div>;
        }
        return <>
            <div style={{padding: "5px"}}> Data taken from <Label>services.clientDevice.detected</Label></div>
            <div style={{padding: "5px 0"}}>
                <div>DEVICE</div>
                <div>
                    <span style={{paddingRight: 20}}><Label>.model</Label> (string) "<Value>{this.props.clientDevice.detected.model}</Value>"</span>
                    <span style={{paddingRight: 20}}><Label>.architecture</Label> (string) "<Value>{this.props.clientDevice.detected.architecture}</Value>"</span>
                </div>
            </div>

            <div style={{padding: "5px 0"}}>
                <div>OS:</div>
                <div>
                    <span style={{paddingRight: 20}}><Label>.platform</Label> (string) "<Value>{this.props.clientDevice.detected.platform}</Value>"</span>
                    <span style={{paddingRight: 20}}><Label>.platformVersion</Label> (string) "<Value>{this.props.clientDevice.detected.platformVersion}</Value>"</span>
                    <span><Label>.bitness</Label> (string) "<Value>{this.props.clientDevice.detected.bitness}</Value>"</span>
                </div>
            </div>

            <div style={{padding: "5px 0"}}>
                <div>MOBILE FLAG:</div>
                <div><Label>.mobile</Label> (boolean) <Value>{this.props.clientDevice.detected.mobile === true ? "true" : (this.props.clientDevice.detected.mobile === false ? "false" : "undefined")}</Value></div>
            </div>

            <div style={{padding: "5px 0"}}>
                <div>BROWSER:</div>
                <div><Label>.brands</Label> (Array&lt;&#123; brand: string; version: string; &#125;&gt;)
                    <div>(array showing the hierarchy of the browser. For example "Not A Brand" &gt; "Chromium" &gt; "Chrome")</div>
                    {this.props.clientDevice.detected.brands.map((brand, i) => {
                        return <div key={i}><Value>{JSON.stringify(brand)}</Value></div>;
                    })}</div>
                <div><Label>.uaFullVersion</Label> (browser version, user agent full version): "<Value>{this.props.clientDevice.detected.uaFullVersion}</Value>"</div>
            </div>
        </>;
    }
    private renderDeviceDetectionData() {
        return <>
            <div style={{padding: "5px"}}> Data taken from <Label>Device</Label></div>
            <div style={{padding: "5px 0"}}>
                <div>OS:</div>
                <div>
                    <span style={{paddingRight: 20}}><Label>.os.name</Label> (string) "<Value>{Device.os.name}</Value>"</span>
                    <span><Label>.os.version</Label> (string) "<Value>{Device.os.version}</Value>"</span>
                </div>
            </div>
            <div style={{padding: "5px 0"}}>
                <div>BROWSER:</div>
                <div>
                    <span style={{paddingRight: 20}}><Label>.browser.name</Label> (string) "<Value>{Device.browser.name}</Value>"</span>
                    <span><Label>.browser.version</Label> (string) "<Value>{Device.browser.version}</Value>"</span>
                </div>
            </div>
            <div style={{padding: "5px 0"}}>
                <div>VIEWPORT:</div>
                <div>
                    <span style={{paddingRight: 20}}><Value>{Device.viewport.width}</Value> x <Value>{Device.viewport.height}</Value></span>
                </div>
            </div>
        </>;
    }
    render() {
        return <div style={{fontSize: 16}}>
            { this.renderUserAgentString() }
            { this.renderClientHints() }
            { this.renderDeviceDetectionData() }
        </div>;
    }
});

export const ClientHintsShowcase = withServices(ComponentBody, ['clientDevice']);